import { createStyles, makeStyles, Paper, Theme, Typography } from '@material-ui/core';
import React from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionSubTitle } from '../../components/SectionSubTitle';
import { globalStyles } from '../../style/GlobalStyles';
import { SchedaBudgetInputProps } from './InformazioniCosti';

// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         root: {
//             flexGrow: 1,
//         },
//         label: {
//             marginTop: "1rem"
//         },
//         boldLabel: {
//             marginTop: "1rem",
//             fontWeight: 900
//         }
//     }),
// );

export default function DettagliSocietaDiPersoneSrlInRegimeDiTrasparenza(props: SchedaBudgetInputProps) {
    const gClasses = globalStyles();
    const { state } = props;
    // const classes = useStyles();

    return (
        <Paper className={gClasses.mainPaper}>
            <SectionSubTitle style={{ cursor: "pointer" }} className={gClasses.boldLabel} text="Società di persone e S.r.l. trasparente"></SectionSubTitle>
            <div>
                <Typography style={{ cursor: "pointer" }} className={gClasses.boldLabel} variant="h6">Socio</Typography>
                <div>
                    <NumberField
                        name="D17_quota"
                        label="Quota"
                        value={state.dettagli.D17_quota}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                        symbol="%"
                    />
                    <NumberField
                        name="E17_contributi"
                        label="Contributi"
                        value={state.dettagli.E17_contributi}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="F17_irpef_add"
                        label="IRPEF/Add."
                        value={state.dettagli.F17_irpef_add}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
            </div>
            <div>
                <Typography style={{ cursor: "pointer" }} className={gClasses.boldLabel} variant="h6">Socio</Typography>
                <div>
                    <NumberField
                        name="D18_quota"
                        label="Quota"
                        value={state.dettagli.D18_quota}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                        symbol="%"
                    />
                    <NumberField
                        name="E18_contributi"
                        label="Contributi"
                        value={state.dettagli.E18_contributi}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="F18_irpef_add"
                        label="IRPEF/Add."
                        value={state.dettagli.F18_irpef_add}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
            </div>
            <div>
                <Typography style={{ cursor: "pointer" }} className={gClasses.boldLabel} variant="h6">Socio</Typography>
                <div>
                    <NumberField
                        name="D19_quota"
                        label="Quota"
                        value={state.dettagli.D19_quota}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                        symbol="%"
                    />
                    <NumberField
                        name="E19_contributi"
                        label="Contributi"
                        value={state.dettagli.E19_contributi}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="F19_irpef_add"
                        label="IRPEF/Add."
                        value={state.dettagli.F19_irpef_add}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
            </div>
            <div>
                <Typography style={{ cursor: "pointer" }} className={gClasses.boldLabel} variant="h6">Socio</Typography>
                <div>
                    <NumberField
                        name="D20_quota"
                        label="Quota"
                        value={state.dettagli.D20_quota}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                        symbol="%"
                    />
                    <NumberField
                        name="E20_contributi"
                        label="Contributi"
                        value={state.dettagli.E20_contributi}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="F20_irpef_add"
                        label="IRPEF/Add."
                        value={state.dettagli.F20_irpef_add}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
            </div>
            <div>
                <Typography style={{ cursor: "pointer" }} className={gClasses.boldLabel} variant="h6">Socio</Typography>
                <div>
                    <NumberField
                        name="D21_quota"
                        label="Quota"
                        value={state.dettagli.D21_quota}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                        symbol="%"
                    />
                    <NumberField
                        name="E21_contributi"
                        label="Contributi"
                        value={state.dettagli.E21_contributi}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="F21_irpef_add"
                        label="IRPEF/Add."
                        value={state.dettagli.F21_irpef_add}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </div>
            </div>
            <div>
                <Typography style={{ cursor: "pointer" }} className={gClasses.boldLabel} variant="h6">Totale</Typography>
                <NumberField
                    name="D22_quota"
                    label="Quota"
                    value={state.dettagli.D22_quota}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    symbol="%"
                />
                <NumberField
                    name="E22_contributi"
                    label="Contributi"
                    value={state.dettagli.E22_contributi}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="F22_irpef_add"
                    label="IRPEF/Add."
                    value={state.dettagli.F22_irpef_add}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
            </div>
        </Paper >
    )
}